import styled from "@emotion/styled"

const EventListItemSubtitle = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export default EventListItemSubtitle
